import React from 'react';
import ProfileLayout from '../../../layout/profile';
import ClientDetailsById from './ClientDetailsById';

export default function Details () {
    return (
        <ProfileLayout>
            <ClientDetailsById />
        </ProfileLayout>
    );
}
